import {AfterViewInit, Component, Input} from '@angular/core';
import {Relevance, RelevanceType, Topic} from "../../interface";
import {HeroRelevanceComponent} from "../hero-relevance/hero-relevance.component";
import {HeroCommentComponent} from "../hero-comment/hero-comment.component";

import {CommonModule} from "@angular/common";
import {HeroSliderComponent} from "../../directive";

@Component({
  selector: 'hero-topic',
  standalone: true,
  imports: [
    HeroRelevanceComponent,
    HeroCommentComponent,
    CommonModule,
    HeroSliderComponent
  ],
  templateUrl: './hero-topic.component.html',
  styleUrl: './hero-topic.component.scss'
})
export class HeroTopicComponent implements AfterViewInit {

  @Input() public sectionTitle: string = '';
  @Input({ required: true }) public topic!: Topic;

  @Input() preview: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() requested: boolean = false;

  // relevance section can be clicked
  @Input() relevance: boolean = false;

  @Input() sliderStepSize: number = 5;
  @Input() feedbacker: boolean = true;

  @Input() feedback1: boolean = false;
  @Input() feedback2: boolean = false;

  private _showRelevance: boolean = false;

  get showRelevance() {
    return this._showRelevance;
  }

  openRelevance() {
    this._showRelevance = true;
  }

  closeRelevance() {
    this._showRelevance = false;
  }


  private _showComment: boolean = false;
  get showComment(){
    return this._showComment;
  }

  openComment() {
    this._showComment = true;
  }

  closeComment() {
    this._showComment = false;
  }

  ngAfterViewInit() {
  }

  requireFeedbacker : boolean[] = [false, false];

  toogleFeedbacker(id:number) {
    this.requireFeedbacker[id] = !this.requireFeedbacker[id];
  }

  protected readonly RelevanceType = RelevanceType;
  protected readonly top = top;

  saveComment(comment: string | null) {
    this.topic.topic_comment = comment;
    this.closeComment();
  }

  saveRelevance(relevance: Relevance|null) {
    this.topic.relevance = relevance;
  }
}
